import SafeIcon from '../common/SafeIcon';
import { FiFilm, FiTrash2 } from 'react-icons/fi';
import { formatBytes, getFileExtension } from '../utils/videoOps';

const FORMAT_BADGE: Record<string, string> = {
  mov: 'bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300',
  webm: 'bg-sky-100 text-sky-600 dark:bg-sky-900/30 dark:text-sky-400',
  mkv: 'bg-fuchsia-100 text-fuchsia-600 dark:bg-fuchsia-900/30 dark:text-fuchsia-400',
  avi: 'bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400',
};

interface FileListItemProps {
  file: File;
  onRemove: (() => void) | null;
}

const FileListItem = ({ file, onRemove }: FileListItemProps) => {
  const ext = getFileExtension(file.name) || 'file';
  const badgeClass =
    FORMAT_BADGE[ext] ??
    'bg-teal-100 text-teal-600 dark:bg-teal-900/30 dark:text-teal-400';

  return (
    <div className="flex items-center justify-between p-3 bg-white/50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 hover:border-teal-200 dark:hover:border-teal-800 transition-colors">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 shrink-0 rounded-lg bg-teal-100 dark:bg-teal-900/30 flex items-center justify-center text-teal-500">
          <SafeIcon icon={FiFilm} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold truncate text-slate-800 dark:text-slate-100" title={file.name}>
            {file.name}
          </p>
          <div className="flex items-center gap-2 mt-0.5">
            <span className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${badgeClass}`}>
              {ext}
            </span>
            <span className="text-[10px] text-slate-400">{formatBytes(file.size)}</span>
          </div>
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remove ${file.name}`}
          className="text-slate-400 hover:text-red-500 p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors ml-2 shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
        >
          <SafeIcon icon={FiTrash2} />
        </button>
      )}
    </div>
  );
};

export default FileListItem;
